import React from 'react';
import {
  Avatar,
  Box,
  Fade,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import BugReportIcon from '@mui/icons-material/BugReport';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import SpeedIcon from '@mui/icons-material/Speed';
import { CARD_SX, formatCount } from '../pages/logsPage.utils';

export default function LogsSummaryCards({ levelSummary, averageDurationSeconds }) {
  const summaryCards = [
    {
      key: 'total',
      title: 'Logs nesta página',
      value: formatCount(levelSummary.totalPage),
      subtitle: `${formatCount(levelSummary.totalGlobal || 0)} registros totais`,
      icon: <BugReportIcon fontSize="small" />,
      accent: '#26c6da',
      gradient: 'linear-gradient(135deg, #e0f7fa, #b2ebf2)',
    },
    {
      key: 'errors',
      title: 'Erros detectados',
      value: formatCount(levelSummary.ERROR),
      subtitle: `${levelSummary.errorRatio || 0}% desta página`,
      icon: <ErrorOutlineIcon fontSize="small" />,
      accent: '#ef5350',
      gradient: 'linear-gradient(135deg, #ffebee, #ffcdd2)',
    },
    {
      key: 'warns',
      title: 'Avisos monitorados',
      value: formatCount(levelSummary.WARN),
      subtitle: 'Tenha atenção aos passos críticos',
      icon: <WarningAmberIcon fontSize="small" />,
      accent: '#ffb300',
      gradient: 'linear-gradient(135deg, #fff8e1, #ffe0b2)',
    },
    {
      key: 'duration',
      title: 'Tempo médio',
      value: `${averageDurationSeconds > 0 ? averageDurationSeconds.toFixed(2) : '0.00'} s`,
      subtitle: 'Baseado nos registros exibidos',
      icon: <SpeedIcon fontSize="small" />,
      accent: '#ab47bc',
      gradient: 'linear-gradient(135deg, #f3e5f5, #e1bee7)',
    },
  ];

  return (
    <Fade in timeout={500}>
      <Grid container spacing={2}>
        {summaryCards.map((card) => (
          <Grid item xs={12} sm={6} md={3} key={card.key}>
            <Box sx={{ ...CARD_SX, background: card.gradient }}>
              <Box sx={{ p: 2.5 }}>
                <Stack direction="row" spacing={2} alignItems="center">
                  <Avatar
                    sx={{
                      bgcolor: card.accent,
                      color: '#fff',
                      boxShadow: '0 10px 25px rgba(0,0,0,0.18)',
                      width: 48,
                      height: 48,
                      flexShrink: 0,
                    }}
                  >
                    {card.icon}
                  </Avatar>
                  <Box>
                    <Typography variant="overline" sx={{ color: 'rgba(15,23,42,0.75)', letterSpacing: 1, fontSize: '0.68rem', lineHeight: 1.2 }}>
                      {card.title}
                    </Typography>
                    <Typography variant="h5" sx={{ fontWeight: 800, color: '#0f172a', lineHeight: 1.2 }}>
                      {card.value}
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'rgba(15,23,42,0.65)' }}>
                      {card.subtitle}
                    </Typography>
                  </Box>
                </Stack>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Fade>

  );
}
